import {
  Disconnectable,
  ElementEventCallback,
  ElementsClickObserverPort,
  ElementsEventObserverPort,
} from '../../../ports'

export class ElementsClickObserver implements ElementsClickObserverPort {
  constructor(
    private readonly elementsEventObserver: ElementsEventObserverPort
  ) {}

  observe(
    elementsSelector: string,
    onClickCallback: ElementEventCallback<'click'>
  ): Disconnectable {
    return this.elementsEventObserver.observe(
      elementsSelector,
      'click',
      onClickCallback
    )
  }
}
